import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=e456c270&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e456c270')) {
      api.createRecord('e456c270', component.options)
    } else {
      api.reload('e456c270', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=e456c270&", function () {
      api.rerender('e456c270', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2sq3CvAhtDUsr/JS/pricehelp.vue"
export default component.exports